import styled from 'styled-components';
import Grid from 'styled-components-grid';

const StyledGrid = styled(Grid)``;

const StyledGridUnit = styled(Grid.Unit)``;

const CustomerWrapper = styled.div`
  width: 100%;
`;

const Customer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${({theme}) => theme.spacing.xsmall};
`;

const CustomerName = styled.div`
  text-align: center;
  margin-top: ${({theme}) => theme.spacing.xsmall};
  font-size: ${({theme}) => theme.fontSize.small};
`;

const CustomerLogo = styled.div`
  width: 100%;
  height: 50px;
  background-image: ${({src}) => (src ? `url(${src})` : null)};
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
`;

const Customers = ({items}) => (
  <CustomerWrapper>
    <StyledGrid halign='center' valign='center'>
      {items?.map(({name, logo}, index) => (
        <StyledGridUnit size={{xs: 1 / 2, sm: 1 / 3, md: 1 / 4}} key={index}>
          <Customer>
            <CustomerLogo src={logo} />
            <CustomerName>{name}</CustomerName>
          </Customer>
        </StyledGridUnit>
      ))}
    </StyledGrid>
  </CustomerWrapper>
);

export default Customers;
